/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { VApplication } from "../../application";
import { LoggerModule } from "@vlinder-web/logger-module-react";
import { getAgent } from "./agent";
import { StorageModule } from "@vlinder-web/storage-module-react";
const is = require("is_js");

const SERVICE_NAME = "DistributionQueuePageService";
const log: any = LoggerModule.getInstance();

export class DistributionQueuePageService {
  private static instance: DistributionQueuePageService;
  private vapp: VApplication;
  private tokenResponse: any = null;

  private constructor(props: any = {}) {
    this.vapp = VApplication.getInstance();
  }

  public static getInstance(props: any = {}): DistributionQueuePageService {
    if (!DistributionQueuePageService.instance) {
      DistributionQueuePageService.instance = new DistributionQueuePageService(
        props
      );
    }
    return DistributionQueuePageService.instance;
  }

  public getStaticPageContent() {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();

    compProps = agent.getStaticPageContentSync({});
    if (compProps) {
      content = { ...content, ...compProps };
    }
    return content;
  }

  public forceResetQStore() {
    const storageService = StorageModule.getInstance();
    storageService.remove("io.vlinder.activeQStore", "memory");
  }

  public async getPageContent() {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();

    //ProfileCard Props
    compProps = await agent.getPaymentQueue({});
    console.log(`msg in payment service 11`, compProps);
    if (compProps?.isDataChanged === false) {
      return null;
    }
    if (compProps) {
      content = { ...content, ...compProps };
    }

    this.tokenResponse = compProps;
    console.log("this.tokenResponse", this.tokenResponse);
    return content;
  }

  public async mqttInit(args: any) {
    let resonse = await getAgent().mqttInit(args);
    console.log(`on mqtt init ers:`, resonse);
    if (resonse?.isDataChanged === false) {
      return null;
    }
    return resonse;
  }

  public async lockToken(args: any) {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();

    //ProfileCard Props
    compProps = await agent.lockToken(args);
    if (compProps) {
      content = { ...content, ...compProps };
    }
    return content;
  }

  public async unLockToken(args: any) {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();

    //ProfileCard Props
    compProps = await agent.unLockToken(args);
    if (compProps) {
      content = { ...content, ...compProps };
    }
    return content;
  }

  public async calloutToken(args: any) {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();

    //ProfileCard Props
    compProps = await agent.calloutToken(args);
    if (compProps) {
      content = { ...content, ...compProps };
    }
    return content;
  }

  public async revokeCallout(args: any) {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();

    //ProfileCard Props
    compProps = await agent.revokeCallout(args);
    if (compProps) {
      content = { ...content, ...compProps };
    }
    return content;
  }

  public async moveToPicker(args: any) {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();

    //ProfileCard Props
    compProps = await agent.moveToPicker(args);
    if (compProps) {
      content = { ...content, ...compProps };
    }
    return content;
  }

  public async getPaymentStatus(args: any) {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();

    //ProfileCard Props
    compProps = await agent.getPaymentStatus(args);
    if (compProps) {
      content = { ...content, ...compProps };
    }
    return content;
  }

  public async completeDist(args: any) {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();

    //ProfileCard Props
    compProps = await agent.completeDist(args);
    if (compProps) {
      content = { ...content, ...compProps };
    }
    return content;
  }

  public async getTokenDetails(args: any) {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();

    //ProfileCard Props
    compProps = await agent.getTokenDetails(args);
    if (compProps) {
      content = { ...content, ...compProps };
    }
    return content;
  }
}
